<div class="OlivorCms">
  <section class="olivorOurStory">
        <div class="container">
              <div class="row" fxLayout="row wrap" fxLayoutAlign="start center">
                    <div class="col-lg-6">
                          <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/IMG_0859_1607782586.JPG?width=2400&optimize=medium" alt="">
                    </div>
                    <div class="col-lg-6 olivorOurStoryInfo">
                          <h2>Our Story</h2>
                          <p>My name is John Roberts. My wife Chrysti and i have been making changes to our diet to be healthier for our grandchildren. Olivor is a combination of our grandsons' names Oliver and Ivor. We wanted them to grow up knowing where their food came from and how to raise it naturally. Think about it, in today's world how many people can actually feed themselves without buying food. Actually being able to raise enough food to feed your family and have surplus to sell to others is a powerful thing, at the most basic level of living. We must all eat to live!</p>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverFarmStore">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <div class="jumbotron">
                                <h2>What We Believe:</h2>
                                <ul>
                                      <li>First and foremost we believe in GOD the father!! We believe that we are stewards of the earth , it's resources and all the animals that go with it.</li>
                                      <li>We believe that some animals are for food and that they should be well cared for and respected until the time they are humanely killed for our nourishment.</li>
                                      <li>We believe in the old way of doing things. Faster is not always better!</li>
                                      <li>We believe quality food takes time patience and GOD'S blessing.</li>
                                      <li>We believe God has giving us the Land to be Good stewards over it</li>
                                      <li>We believe in Pastured, regenerative farming techniques without out herbicides and pesticides and the humane treatment of our animals</li>
                                      <li>We believe Local food is better tasting and more nutritious for our bodie</li>
                                      <li>We believe in sharing this with as many people as possible</li>
                                </ul>
                          </div>
                    </div>
              </div>
        </div>
  </section>
  <section class="olivorWeBelieve">
        <div class="container">
              <div class="row" fxLayout="row wrap" fxLayoutAlign="start center">
                    <div class="col-lg-6">
                          <h2>What We Believe: </h2>
                         <ul>
                          <li>The old ways should not be forgotten</li>
                          <li>Local Regenerative Farming techniques are better for the Environment</li>
                          <li>Humanely raised food taste better</li>
                          <li>The variety available is unbelievable</li>
                          <li>Pasture Raised food is an experience that takes us back to a simpler time</li>
                         </ul>
                         <button class="bgDarkBrown">Learn More</button>
                    </div>
                    <div class="col-lg-6 olivorOurStoryInfo">
                          <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Untitled-2_1597847282.png?width=2400&optimize=medium" alt="">
                    </div>
              </div>
        </div>
  </section>
  <section class="olivorBrands">
        <div class="container">
              <div class="row" fxLayout="row wrap" fxLayoutAlign="start center">
                    <div class="col-lg-12">
                          <img src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Untitled-1_1597755565.png?width=2400&optimize=medium" alt="">
                    </div>
              </div>
        </div>
  </section>
</div>